export default __webpack_public_path__ + "static/media/natour_tour.7b47b990.png";